document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.getElementById("ring-resize-wrapper");
  
  // Early exit if wrapper doesn't exist
  if (!wrapper) {
    console.log("Ring resize wrapper not found - feature not enabled for this product");
    return;
  }

  // External elements (outside wrapper)
  const customizationCheckbox = document.getElementById("customization-checkbox");
  const productForm = document.querySelector('form[action*="/cart/add"]');

  // Scoped elements (inside wrapper)
  const resizeCurrentDisplay = wrapper.querySelector("#resize-current-display");
  const resizeOptionsContainer = wrapper.querySelector("#resize-options-container");
  const selectedSizeDisplay = wrapper.querySelector("#selected-size-display");
  const selectedRingSizeInput = wrapper.querySelector("#selected-ring-size");
  const resizeNeededInput = wrapper.querySelector("#resize-needed");
  const sizeButtons = wrapper.querySelectorAll(".size-button");
  const deliveryMessage = wrapper.querySelector("#resize-delivery-message");
  const priceDisplay = wrapper.querySelector("#resize-price-display");
  const safeguardInput = wrapper.querySelector("#safeguard-yes");
  const resizeRuleInput = wrapper.querySelector("#resize-rule");
  const materialInput = wrapper.querySelector("#jewellery-material");
  const originalSizeInput = wrapper.querySelector("#original-size");
  const productSkuInput = wrapper.querySelector("#product-sku");

  // ════════════════════════════════════════════════════════════════════════
  // CART CACHE - Simple short-lived cache for /cart.js
  // ════════════════════════════════════════════════════════════════════════
  let cachedCart = null;
  let cartCacheTime = 0;
  const CART_CACHE_TTL = 25000; // 25 seconds

  async function getCart() {
    const now = Date.now();

    if (cachedCart && now - cartCacheTime < CART_CACHE_TTL) {
      console.log("[CART CACHE] Using memory cache");
      return cachedCart;
    }

    // localStorage fallback
    try {
      const stored = localStorage.getItem("temp_cart_cache");
      if (stored) {
        const parsed = JSON.parse(stored);
        if (now - parsed.timestamp < CART_CACHE_TTL) {
          console.log("[CART CACHE] Using localStorage cache");
          cachedCart = parsed.data;
          cartCacheTime = parsed.timestamp;
          return cachedCart;
        }
      }
    } catch (e) {
      console.warn("localStorage cache read failed", e);
    }

    // Fresh fetch
    console.log("[CART CACHE] Fetching fresh /cart.js");
    const res = await fetch("/cart.js");
    if (!res.ok) {
      throw new Error(`Cart fetch failed: ${res.status}`);
    }
    const data = await res.json();

    // Update both caches
    cachedCart = data;
    cartCacheTime = now;
    try {
      localStorage.setItem(
        "temp_cart_cache",
        JSON.stringify({ timestamp: now, data })
      );
    } catch (e) {
      console.warn("localStorage cache write failed", e);
    }

    return data;
  }

  // ════════════════════════════════════════════════════════════════════════
  // RESIZE VARIANT DATA & SETTINGS
  // ════════════════════════════════════════════════════════════════════════
  const resizeVariantsData = wrapper.querySelector("#resize-variants-data");
  let RESIZE_VARIANT_MAP = {};

  if (resizeVariantsData) {
    try {
      RESIZE_VARIANT_MAP = JSON.parse(resizeVariantsData.textContent);
    } catch (e) {
      console.error("Error parsing resize variants:", e);
    }
  }

  const CUSTOMIZATION_PRODUCT_ID =
    window.ringResizeSettings?.customizationProductId || "15558484558198";
  const MONEY_FORMAT = window.ringResizeSettings?.moneyFormat || "{{amount}}";

  // ════════════════════════════════════════════════════════════════════════
  // UTILITY: Format price using Shopify's money format
  // ════════════════════════════════════════════════════════════════════════
  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2);
    return MONEY_FORMAT.replace("{{amount}}", value)
      .replace("{{amount_no_decimals}}", Math.round(cents / 100))
      .replace("{{amount_with_comma_separator}}", value.replace(".", ","));
  }

  // ════════════════════════════════════════════════════════════════════════
  // FEATURE : Display resize price or free message
  // ════════════════════════════════════════════════════════════════════════
  function updateResizePriceDisplay(isCurrent) {
    if (!priceDisplay) return;

    const isSafeguard = safeguardInput?.value === "true" || safeguardInput?.value === true;

    // If current size selected, hide price display
    if (isCurrent) {
      priceDisplay.style.display = "none";
      priceDisplay.textContent = "";
      return;
    }

    // Feature 3: Show free message if safeguard is active
    if (isSafeguard) {
      priceDisplay.textContent = "Ring Resizing for this product is free";
      priceDisplay.style.display = "block";
      return;
    }

    // Show loading state
    priceDisplay.textContent = "Loading Ring Resize Price....";
    priceDisplay.style.display = "block";

    // Feature 1 & 2: Get and display resize price
    // Use requestAnimationFrame to ensure loading text is visible
    requestAnimationFrame(() => {
      const resizeRule = resizeRuleInput?.value || "";
      const material = materialInput?.value || "";

      const normalize1 = (s) => s?.trim().toLowerCase().replace(" / ", "-/-").replace(/\s+/g, "-") || "";
      const normalize2 = (s) => s?.trim().toLowerCase().replace(/\s+/g, "-") || "";

      const lookupKey = `${normalize1(resizeRule)}_${normalize2(material)}`;
      const resizeVariantData = RESIZE_VARIANT_MAP[lookupKey];

      if (resizeVariantData && resizeVariantData.price) {
        const formattedPrice = formatMoney(resizeVariantData.price);
        priceDisplay.textContent = `Ring Resize Charges will be : ${formattedPrice}`;
        priceDisplay.style.display = "block";
      } else {
        // Fallback if variant not found
        priceDisplay.style.display = "none";
        console.warn(`No resize variant found for key: ${lookupKey}`);
      }
    });
  }

  // ════════════════════════════════════════════════════════════════════════
  // MODAL SETUP
  // ════════════════════════════════════════════════════════════════════════
  const resizeInfoTrigger = wrapper.querySelector("#resize-info-trigger");
  const resizeInfoModal = wrapper.querySelector("#resize-info-modal");
  const resizeModalOverlay = wrapper.querySelector("#resize-modal-overlay");
  const resizeModalClose = wrapper.querySelector("#resize-modal-close");
  const resizeModalBody = wrapper.querySelector("#resize-modal-body");
  const resizeInfoContent = wrapper.querySelector("#resize-info-content");

  
  if (resizeInfoTrigger && resizeInfoModal && resizeInfoContent) {
    resizeInfoTrigger.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      resizeModalBody.innerHTML = resizeInfoContent.innerHTML;
      resizeInfoModal.style.display = "block";
      document.body.style.overflow = "hidden";
      document.body.classList.add("info-modal-open");
    });

    const closeModal = () => {
      resizeInfoModal.style.display = "none";
      document.body.style.overflow = "";
      document.body.classList.remove("info-modal-open");
    };

    resizeModalClose?.addEventListener("click", closeModal);
    resizeModalOverlay?.addEventListener("click", closeModal);

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && resizeInfoModal.style.display === "block") {
        closeModal();
      }
    });
  }

  if (!productForm) {
    console.error("Product form not found");
    return;
  }

  // ════════════════════════════════════════════════════════════════════════
  // ACCORDION TOGGLE
  // ════════════════════════════════════════════════════════════════════════
  resizeCurrentDisplay?.addEventListener("click", function () {
    const isOpen = resizeOptionsContainer.style.display === "block";
    resizeOptionsContainer.style.display = isOpen ? "none" : "block";
    this.classList.toggle("active");
  });

  // ════════════════════════════════════════════════════════════════════════
  // SIZE BUTTON SELECTION
  // ════════════════════════════════════════════════════════════════════════
  sizeButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const selectedSize = this.dataset.size;
      const isCurrent = this.dataset.isCurrent === "true";

      sizeButtons.forEach((btn) => btn.classList.remove("selected"));
      this.classList.add("selected");

      deliveryMessage?.classList.toggle("active", !isCurrent);

      selectedSizeDisplay.textContent = selectedSize + (isCurrent ? " - Current Size" : "");
      selectedRingSizeInput.value = selectedSize;
      resizeNeededInput.value = isCurrent ? "false" : "true";

      // Update price display based on selection
      updateResizePriceDisplay(isCurrent);

      resizeOptionsContainer.style.display = "none";
      resizeCurrentDisplay?.classList.remove("active");
    });
  });

  // ════════════════════════════════════════════════════════════════════════
  // FORM SUBMIT INTERCEPTOR
  // ════════════════════════════════════════════════════════════════════════
  document.addEventListener(
    "submit",
    function (e) {
      if (!e.target.matches('form[action*="/cart/add"]')) return;

      const needsResize = resizeNeededInput?.value === "true";
      const needsCustomization = customizationCheckbox?.checked;

      if (!needsResize && !needsCustomization) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const addButton = e.target.querySelector(
        'button[type="submit"], input[type="submit"], button[name="add"]'
      );
      if (addButton) {
        addButton.disabled = true;
        addButton.classList.add("is-loading");
        const originalText = addButton.textContent || addButton.value || "Add to cart";
        addButton.textContent = addButton.value = "Adding to cart...";
        addButton.dataset.originalText = originalText;
      }

      handleCustomCartAdd(addButton);
    },
    true
  );

  // ════════════════════════════════════════════════════════════════════════
  // CUSTOM CART ADD HANDLER
  // ════════════════════════════════════════════════════════════════════════
  async function handleCustomCartAdd(addButton) {
    console.log("=== CUSTOM CART ADD STARTED ===");

    try {
      const formData = new FormData(productForm);
      const mainVariantId = formData.get("id");
      const quantity = parseInt(formData.get("quantity")) || 1;
      const needsResize = resizeNeededInput?.value === "true";
      const needsCustomization = customizationCheckbox?.checked;
      const isSafeguardActive = safeguardInput?.value === "true" || safeguardInput?.value === true;

      if (!mainVariantId) throw new Error("Please select a product variant");

      // Check if this base variant is already in cart (using cached fetch)
      const cart = await getCart();
      const alreadyInCart = cart.items.some(
        (item) => String(item.variant_id) === String(mainVariantId)
      );

      if (alreadyInCart) {
        throw new Error("MAX_IN_CART");
      }

      // Build items to add
      let properties = {};
      const excludedProps = ["resize rule", "metal & purity", "ring size"];

      for (const [key, value] of formData.entries()) {
        if (key.startsWith("properties[")) {
          const match = key.match(/properties\[([^\]]+)\]/);
          if (match) {
            const propName = match[1];
            const lowerName = propName.toLowerCase();
            if (!excludedProps.includes(lowerName) && !lowerName.startsWith("attr:")) {
              properties[propName] = value;
            }
          }
        }
      }

      if (needsCustomization) {
        properties["Customization"] = "Yes";
      }

      const items = [
        {
          id: mainVariantId,
          quantity,
          properties: { ...properties },
        },
      ];

      if (needsResize) {
        const resizeRule = resizeRuleInput?.value || "";
        const material = materialInput?.value || "";

        const normalize1 = (s) => s?.trim().toLowerCase().replace(" / ", "-/-").replace(/\s+/g, "-") || "";
        const normalize2 = (s) => s?.trim().toLowerCase().replace(/\s+/g, "-") || "";

        const lookupKey = `${normalize1(resizeRule)}_${normalize2(material)}`;
        const resizeVariantData = RESIZE_VARIANT_MAP[lookupKey];
        const resizeVariantId = resizeVariantData?.id;

        const originalSize = originalSizeInput?.value || "";
        const newSize = selectedRingSizeInput.value;

        if (originalSize !== newSize) {
          const productSku = productSkuInput?.value || "N/A";

          if (isSafeguardActive) {
            items[0].properties["Resize Needed"] = "Yes";
            items[0].properties["Original Size"] = originalSize;
            items[0].properties["New Size"] = newSize;
          } else if (resizeVariantId) {
            items.push({
              id: resizeVariantId,
              quantity,
              properties: {
                "Resize Needed for (SKU)": productSku,
                "Original Size": originalSize,
                "New Size": newSize,
              },
            });
          } else {
            console.warn(`No resize variant found for key: ${lookupKey} (and no safeguard active)`);
          }
        }
      }

      if (needsCustomization) {
        items.push({
          id: CUSTOMIZATION_PRODUCT_ID,
          quantity,
          properties: { _linked_to: mainVariantId },
        });
      }

      console.log("Adding items:", items);

      const cartDrawer = document.querySelector("cart-drawer");
      const requestData = { items };

      let sectionsToRender = ["cart-drawer", "cart-icon-bubble"];
      let sectionsUrl = window.location.pathname;

      if (cartDrawer && typeof cartDrawer.getSectionsToRender === "function") {
        sectionsToRender = cartDrawer.getSectionsToRender().map((s) => s.section || s.id);
        requestData.sections = sectionsToRender;
        requestData.sections_url = sectionsUrl;
        if (typeof cartDrawer.setActiveElement === "function") {
          cartDrawer.setActiveElement(document.activeElement);
        }
      }

      const addResponse = await tryAddToCart(requestData);

      await addResponse.json(); // we don't really need the data here

      await new Promise((r) => setTimeout(r, 200));

      const params = new URLSearchParams();
      params.set("sections", sectionsToRender.join(","));
      if (sectionsUrl) params.set("sections_url", sectionsUrl);

      const sectionsResponse = await fetch(`/cart?${params.toString()}`);
      if (!sectionsResponse.ok) {
        throw new Error(`Sections fetch failed: ${sectionsResponse.status}`);
      }

      const sectionsData = await sectionsResponse.json();

      if (cartDrawer) {
        if (sectionsData["cart-drawer"]?.trim()) {
          cartDrawer.renderContents({ sections: sectionsData });
          cartDrawer.open();
        } else {
          cartDrawer.open();
        }
        cartDrawer.classList.remove("is-empty");
      } else {
        window.location.href = "/cart";
      }

      // Invalidate cache after successful add
      cachedCart = null;
      cartCacheTime = 0;
      try {
        localStorage.removeItem("temp_cart_cache");
      } catch (e) {}

      document.documentElement.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    } catch (error) {
      console.error("Error adding to cart:", error);

      let userMessage = "Sorry, we couldn't add this to your cart right now. Please try again.";

      if (error.message === "MAX_IN_CART") {
        userMessage = "Maximum quantity already in cart!";
      } else if (error.message.includes("429") || error.message.includes("HTML")) {
        userMessage =
          "A temporary security check is preventing this action. " +
          "Please wait 1–2 minutes, refresh the page, or try from a different network (mobile data often helps).";
      }

      alert(userMessage);
    } finally {
      if (addButton) {
        addButton.disabled = false;
        addButton.classList.remove("is-loading");
        addButton.textContent = addButton.value = addButton.dataset.originalText || "Add to cart";
      }
    }
  }

  // ════════════════════════════════════════════════════════════════════════
  // HELPER: Add to cart with retry on 429
  // ════════════════════════════════════════════════════════════════════════
  async function tryAddToCart(requestData) {
    const maxRetries = 1;
    let lastError;

    for (let attempt = 0; attempt <= maxRetries; attempt++) {
      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        });

        if (response.status === 429 && attempt < maxRetries) {
          console.warn("429 → waiting 3s before retry...");
          await new Promise((r) => setTimeout(r, 3000));
          continue;
        }

        if (!response.ok) {
          let errorBody = "";
          const ct = response.headers.get("content-type");
          if (ct?.includes("application/json")) {
            errorBody = await response.json().then(JSON.stringify);
          } else {
            errorBody = (await response.text()).substring(0, 300) + "...";
          }
          throw new Error(`Cart add failed: ${response.status} - ${errorBody}`);
        }

        return response;
      } catch (err) {
        lastError = err;
        if (attempt === maxRetries) throw lastError;
      }
    }

    throw lastError;
  }
});